/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const HomeElectronics = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M38.2001 12.34H35.2301V5.7C35.2301 4.76 34.4701 4 33.5301 4C32.5901 4 31.8301 4.76 31.8301 5.7V12.34H25.9701V5.7C25.9701 4.76 25.2101 4 24.2701 4C23.3301 4 22.5701 4.76 22.5701 5.7V12.34H19.6001C18.6601 12.34 17.9001 13.1 17.9001 14.04V19.71C17.9001 25.19 21.9401 29.73 27.1901 30.56C27.0901 33.91 24.3401 36.61 20.9601 36.61C17.5801 36.61 14.7201 33.81 14.7201 30.38V9.32C14.7201 6.39 12.3301 4 9.40008 4C6.47008 4 4.08008 6.39 4.08008 9.32V30.8C4.08008 31.74 4.84008 32.5 5.78008 32.5C6.72008 32.5 7.48008 31.74 7.48008 30.8V9.32C7.48008 8.26 8.34008 7.39 9.41008 7.39C10.4801 7.39 11.3401 8.25 11.3401 9.32V30.38C11.3401 35.69 15.6601 40.01 20.9701 40.01C26.2801 40.01 30.4901 35.79 30.5901 30.57C35.8501 29.75 39.9001 25.21 39.9001 19.72V14.05C39.9001 13.11 39.1401 12.35 38.2001 12.35V12.34Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default HomeElectronics
